import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-repeat-one-icon',
  templateUrl: './bmcore-repeat-one-icon.component.html',
  styleUrls: ['./bmcore-repeat-one-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreRepeatOneIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
